var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.33203 13.0052C1.33203 12.1212 1.68322 11.2733 2.30834 10.6482C2.93346 10.0231 3.78131 9.67188 4.66536 9.67188H11.332C12.2161 9.67188 13.0639 10.0231 13.6891 10.6482C14.3142 11.2733 14.6654 12.1212 14.6654 13.0052C14.6654 13.4472 14.4898 13.8712 14.1772 14.1837C13.8646 14.4963 13.4407 14.6719 12.9987 14.6719H2.9987C2.55667 14.6719 2.13275 14.4963 1.82019 14.1837C1.50763 13.8712 1.33203 13.4472 1.33203 13.0052Z",
    stroke: "#243142",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 6.33594C9.38071 6.33594 10.5 5.21665 10.5 3.83594C10.5 2.45523 9.38071 1.33594 8 1.33594C6.61929 1.33594 5.5 2.45523 5.5 3.83594C5.5 5.21665 6.61929 6.33594 8 6.33594Z",
    stroke: "#243142",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.49f0f8d976278207d636e60c43bfc245.svg";
export { ForwardRef as ReactComponent };